import { featuredArticles } from "@/mocks/articles";

export default function ArticlesGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            SEO Resources
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Complete <span className="text-primary-500">Sugargoo Spreadsheet</span> Knowledge Base
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Dive deep into every aspect of Sugargoo — from beginner tutorials and shipping cost breakdowns to advanced pro strategies and safety analysis. Each guide is packed with actionable insights and real data.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <a
              key={article.slug}
              href={`/article/${article.slug}`}
              className="group flex flex-col rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-300 hover:shadow-sm transition-all cursor-pointer overflow-hidden"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="mb-2">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-semibold uppercase tracking-wider">
                    {article.badge}
                  </span>
                </div>
                <h4 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors line-clamp-2">
                  {article.title}
                </h4>
                <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors mt-auto">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-[10px] group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/article/sugargoo-spreadsheet-ultimate-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white hover:bg-primary-600 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            Browse All Guides
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}